module.exports = __webpack_public_path__ + "img/f-thermometer-img1-2.c103c283.png";